import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import "antd/dist/antd.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n'
ReactDOM.render(<App />, document.getElementById("root"));

reportWebVitals();
